import { Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ContractTaskDto } from "../../../../../../autogen/bff-api";
import { EditButton } from "../EditButton";
import { EditDescription } from "./EditDescription";

interface Props {
  task: ContractTaskDto;
  onEditComleted: (task: ContractTaskDto) => void;
}

export const Description = ({ task, onEditComleted }: Props) => {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);
  return (
    <Flex w="100%" flexDirection={"column"} padding="10px">
      <Flex>
        <Text fontSize={"md"} fontWeight="bold">
          {t("Description")}
        </Text>
        {task.canEdit && !isEditing && <EditButton name="edit-description-button" onClick={() => setIsEditing(true)} />}
      </Flex>
      <Flex mt="5px">
        {isEditing ? (
          <EditDescription
            task={task}
            onEditComleted={(e) => {
              setIsEditing(false);
              onEditComleted(e);
            }}
            onCancel={() => setIsEditing(false)}
          />
        ) : (
          <Text fontWeight={"light"} whiteSpace="pre-line">
            {task.description}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
